export function getTelegramWebApp() {
  return window.Telegram?.WebApp ?? null
}
